"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _style = require("./style");

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var processEvents = function processEvents(events, serviceCanceled) {
  return (0, _ramda.pipe)((0, _ramda.map)((0, _ramda.assoc)('serviceCanceled', serviceCanceled)), mapIndexed(function (item, index) {
    return (0, _ramda.assoc)('index', index, item);
  }), (0, _ramda.map)((0, _ramda.when)((0, _ramda.propEq)('index', events.length - 1), (0, _ramda.assoc)('isLast', true))), (0, _ramda.map)((0, _ramda.when)(function (_ref) {
    var index = _ref.index;
    return (0, _ramda.propEq)('completed', true, events[index + 1] || {});
  }, (0, _ramda.assoc)('nextIsCompleted', true))))(events);
};

var Timeline = function Timeline(_ref2) {
  var events = _ref2.events,
      serviceCanceled = _ref2.serviceCanceled;
  return _react["default"].createElement(_style.TimeLineStyled, null, processEvents(events, serviceCanceled).map(function (event) {
    return _react["default"].createElement(_style.EventContainer, {
      key: event.title
    }, _react["default"].createElement(_style.GraphContainer, null, _react["default"].createElement(_style.CircleStyled, event), !event.isLast && _react["default"].createElement(_style.LineStyled, event)), _react["default"].createElement(_style.TextContainer, null, _react["default"].createElement(_style.TitleStyled, event, event.title), event.date && _react["default"].createElement(_style.DateStyled, event, event.date)));
  }));
};

Timeline.propTypes = {
  serviceCanceled: _propTypes["default"].bool,
  events: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    date: _propTypes["default"].string,
    title: _propTypes["default"].string,
    withIncidence: _propTypes["default"].bool,
    completed: _propTypes["default"].bool
  }))
};
Timeline.defaultProps = {
  serviceCanceled: false,
  events: []
};
var _default = Timeline;
exports["default"] = _default;